import React from 'react';
import { Redirect, useRouteMatch } from 'react-router-dom';

import { useMerchantContext } from '../MerchantContext';

type MerchantRouteParams = {
  feature: 'merchant';
  slug: string;
};

const MerchantRoot = () => {
  const { params } = useRouteMatch<MerchantRouteParams>();
  const { merchantVenues } = useMerchantContext();

  const isDaasMerchant = !!merchantVenues?.some(venue => venue.type === 'daas');

  if (isDaasMerchant) {
    return <Redirect to={`/merchant/${params.slug}/access`} />;
  }

  return <Redirect to={`/merchant/${params.slug}/insights`} />;
};

export default MerchantRoot;
